import { Button } from 'components';
import { useEmployees } from 'hooks/useEmployees';
import { useState } from 'react';
import NumberFormat, { NumberFormatProps } from 'react-number-format';
import { unmaskNumber } from 'util/masks';

import SearchIcon from '@mui/icons-material/Search';
import { Grid, InputAdornment, TextField } from '@mui/material';

const InputCpf: React.FC<NumberFormatProps> = (props) => {
  return <NumberFormat format="###.###.###-##" {...props} />;
};

export const EmployeeSearchBar = () => {
  const { searchEmployees } = useEmployees();

  const [cpf, setCpf] = useState<string>('');

  const [employee, setEmployee] = useState<string>('');

  const handleChangeEmployee = (event: any) => {
    setEmployee(event.target.value);
  };

  const handleChangeCPF = (event: any) => {
    setCpf(event.target.value);
  };

  const handleSearch = () => {
    if (!cpf && !employee) {
      searchEmployees('');
      return;
    }

    if (cpf) {
      searchEmployees(unmaskNumber(cpf));
    } else if (employee) {
      searchEmployees(employee.toLocaleLowerCase().trim());
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item>
        <TextField
          id="employee"
          disabled={Boolean(cpf) && true}
          placeholder="Colaborador"
          variant="outlined"
          size="small"
          value={employee}
          onChange={handleChangeEmployee}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item>
        <TextField
          id="cpf"
          value={cpf}
          onChange={handleChangeCPF}
          InputProps={{ inputComponent: InputCpf as any }}
          disabled={Boolean(employee) && true}
          placeholder="CPF"
          variant="outlined"
          size="small"
        />
      </Grid>
      <Grid item alignSelf="flex-end">
        <Button
          size="large"
          sx={{ maxHeight: 38, color: '#FFF', mb: 1 }}
          onClick={handleSearch}
        >
          Buscar
        </Button>
      </Grid>
    </Grid>
  );
};
